import ShiftPlanTabs from './ShiftPlanTabs';

export default ShiftPlanTabs;
export * from './ShiftPlanTabs';
